import { CompanyDayJobStat_Read } from '@treadinc/horizon-api-spec';

export class CompanyDayJobStat {
  constructor(
    private _accepted_count: number,
    private _assigned_count: number,
    private _canceled_count: number,
    private _capacity_available_count: number,
    private _capacity_total_count: number,
    private _completed_count: number,
    private _enroute_count: number,
    private _has_been_accepted_count: number,
    private _loaded_count: number,
    private _rejected_count: number,
    private _sent_count: number,
    private _total_count: number,
    private _unassigned_count: number,
    private _unloaded_count: number,
    private _day: string,
    private _orders_total_count: number,
    private _orders_pending_request_count: number,
    private _orders_external_count: number,
    private _orders_external_only_count: number,
  ) {}

  public get acceptedCount() {
    return this._accepted_count;
  }

  public get assignedCount() {
    return this._assigned_count;
  }

  public get canceledCount() {
    return this._canceled_count;
  }

  public get capacityAvailableCount() {
    return this._capacity_available_count;
  }

  public get capacityTotalCount() {
    return this._capacity_total_count;
  }

  public get completedCount() {
    return this._completed_count;
  }

  public get enrouteCount() {
    return this._enroute_count;
  }

  public get hasBeenAcceptedCount() {
    return this._has_been_accepted_count;
  }

  public get loadedCount() {
    return this._loaded_count;
  }

  public get rejectedCount() {
    return this._rejected_count;
  }

  public get sentCount() {
    return this._sent_count;
  }

  public get totalCount() {
    return this._total_count;
  }

  public get unassignedCount() {
    return this._unassigned_count;
  }

  public get unloadedCount() {
    return this._unloaded_count;
  }

  public get day() {
    return this._day;
  }

  public get ordersTotalCount() {
    return this._orders_total_count;
  }

  public get ordersPendingRequestCount() {
    return this._orders_pending_request_count;
  }

  public get ordersExternalCount() {
    return this._orders_external_count;
  }

  public get ordersExternalOnlyCount() {
    return this._orders_external_only_count;
  }

  public static parse(proto: CompanyDayJobStat_Read) {
    return new CompanyDayJobStat(
      proto.accepted_count,
      proto.assigned_count,
      proto.canceled_count,
      proto.capacity_available_count,
      proto.capacity_total_count,
      proto.completed_count,
      proto.enroute_count,
      proto.has_been_accepted_count,
      proto.loaded_count,
      proto.rejected_count,
      proto.sent_count,
      proto.total_count,
      proto.unassigned_count,
      proto.unloaded_count,
      proto.day,
      proto.orders_total_count,
      proto.orders_pending_request_count,
      proto.orders_external_count,
      proto.orders_external_only_count,
    );
  }
}
